export function nextSlice(callback) {
  /* istanbul ignore next */
  Promise.resolve().then(callback);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-menu/es/utils/timeUtil.js
// module id = 678
// module chunks = 0